import mapDatesToRequest from './mappers/mapDatesToRequest'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(date: string, time: string): Promise<boolean> {
    const requestBody: IRequestBody = mapDatesToRequest(date, time)
    const response = await api.fetch('/api/v2/misc/checkdate', {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return handleResponse(response)
  }
}

export interface IRequestBody {
  date?: string
  time?: string
}
